module.exports = __webpack_public_path__ + "img/beian.093bd141.png";